var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1007",
    "data-name": "Group 1007",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.041,
    height: 18.177,
    viewBox: "0 0 17.041 18.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M29.846,11.787a3.193,3.193,0,0,0-2.57,1.3l-5.015-2.563a3.2,3.2,0,0,0-.1-2.1l5.256-3.158a3.182,3.182,0,1,0-.547-.914L21.6,7.516a3.195,3.195,0,1,0,.2,3.962l5,2.556a3.2,3.2,0,1,0,3.052-2.248Zm0-10.722a2.13,2.13,0,1,1-2.13,2.13A2.133,2.133,0,0,1,29.846,1.065ZM19.2,11.751a2.13,2.13,0,1,1,2.13-2.13A2.133,2.133,0,0,1,19.2,11.751Zm10.651,5.361a2.13,2.13,0,1,1,2.13-2.13A2.133,2.133,0,0,1,29.846,17.112Z",
    transform: "translate(-16)",
    fill: "#67E1AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b8274847b6a854faba10b41a2ea7ef02.svg";
export { ForwardRef as ReactComponent };